// SAME SERIES on the product page (snippets/product-series.liquid): follows the color chosen on the page.
// Items with data-colors swap to that color's image and link; items without a color option whose title holds
// the color move ahead of the others of that kind (their places in the list stay the same).
if (!customElements.get('product-series')) {
  customElements.define(
    'product-series',
    class ProductSeries extends HTMLElement {
      connectedCallback() {
        this.colorIndex = Number(this.dataset.colorPosition) - 1;
        if (this.colorIndex < 0) return;
        this.order(this.dataset.currentColor);
        if (typeof subscribe !== 'function') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section || !data.variant) return;
          this.show(data.variant.options[this.colorIndex]);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      show(color) {
        this.querySelectorAll('[data-colors]').forEach((item) => {
          const hit = JSON.parse(item.dataset.colors)[color];
          const img = item.querySelector('.product-series__media img');
          item.querySelector('a').href = hit ? hit.url : item.dataset.defaultUrl;
          if (!img) return;
          img.srcset = hit ? hit.srcset : item.dataset.defaultSrcset;
          img.src = hit ? hit.src : item.dataset.defaultSrc;
        });
        this.order(color);
      }

      order(color) {
        const items = [...this.querySelectorAll('[data-has-color="false"]')];
        if (items.length < 2 || !color) return;
        const sorted = [...items.filter((i) => i.dataset.title.includes(color)), ...items.filter((i) => !i.dataset.title.includes(color))];
        if (sorted.every((item, n) => item === items[n])) return;
        // Mark each item's place, then fill the places in the new order.
        const marks = items.map((item) => {
          const mark = document.createComment('');
          item.replaceWith(mark);
          return mark;
        });
        marks.forEach((mark, n) => mark.replaceWith(sorted[n]));
      }
    }
  );
}
